import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { ionEyeOffOutline, ionEyeOutline } from '@ng-icons/ionicons';

@Component({
  selector: 'app-password-input',
  standalone: true,
  imports: [CommonModule, FormsModule, NgIcon],
  providers: [
    provideIcons({ ionEyeOutline, ionEyeOffOutline }),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true
    }
  ],
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.css'
})
export class PasswordInputComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() tabindex = 0;
  @Input() disabled = false;
  @Input() customClass = 'w-full px-3 sm:px-4 py-2.5 sm:py-3 pr-12 text-base border rounded-3xl focus:outline-none';

  @Output() blur = new EventEmitter<void>();
  @Output() input = new EventEmitter<string>();

  showPassword = false;
  value = '';

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onInputChange(value: string) {
    this.value = value;
    this.onChange(value);
    this.input.emit(value);
  }

  onBlur() {
    this.onTouched();
    this.blur.emit();
  }

  onKeydown(event: KeyboardEvent) {
    // Propagate the event to parent
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  // ControlValueAccessor implementation
  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
